export default "__VITE_ASSET__DNzPZkFJ__"